import React from "react";
import { AppBar, Toolbar, Box, Container } from "@mui/material";
import ZHP from "../assets/images/ZHP_ID.svg";
import NavLinkItem from "./NavLinkItem";
import { menuItems } from "./menuItems";
import LoginNavItem from "./LoginNavItem";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

export default function Header() {
  const { accounts } = useMsal();
  const navigate = useNavigate();

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{ backgroundColor: "transparent", paddingTop: "10px" }}
    >
      <Box>
        <Toolbar sx={{ justifyContent: "center" }}>
          <img
            src={ZHP}
            alt="Identyfikator Związku Harcerstwa Polskiego"
            style={{ height: 54, cursor: "pointer" }}
            onClick={() => navigate("/")}
          />
        </Toolbar>

        <Box sx={{ pt: 2 }}>
          <Container>
            <Toolbar variant="dense" sx={{ justifyContent: "center", gap: 1 }}>
              {menuItems.map((item) => (
                <NavLinkItem key={item.to} label={item.label} to={item.to} />
              ))}
              {accounts.length > 0 && (
                <NavLinkItem label="Lista zgłoszeń" to="/lista" />
              )}
              <LoginNavItem />
            </Toolbar>
          </Container>
        </Box>
      </Box>
    </AppBar>
  );
}
